import api from '../api';
import { normalizeUrl } from '../../utils/url';
import {
  USE_LIVE_SEARCH_MOCKS,
  getFormMockConfig,
  getFormPostMockResponse,
  shouldUseFormMock,
} from './formMockConfig';

/**
 * Get form configuration from the API (local mocks when USE_FORM_MOCKS).
 * @param {string} formUrl - Form URL from API or page action (passed as-is to api.get after normalize)
 * @param {object} [params={}] - Query params (same contract as former getManagerData default branch)
 * @returns {Promise<ApiFormResponse>} Form configuration
 */
export const getFormConfig = async (formUrl, params = {}) => {
  if (!formUrl) {
    throw new Error('formUrl is required');
  }

  if (shouldUseFormMock(formUrl)) {
    return getFormMockConfig(formUrl);
  }

  const url = normalizeUrl(formUrl);
  const response = await api.get(url, { params });
  return response.data;
};

/**
 * Submit form data to the server
 * @param {string} sendFormUrl - The URL to submit the form to (from GET response)
 * @param {ApiFormPostRequestBody} transformedData - Form data in API format
 * @returns {Promise<ApiFormPostResponse>} The form submission response data
 */
export const postFormSubmission = async (sendFormUrl, transformedData) => {
  if (!sendFormUrl) {
    throw new Error('sendFormUrl is required');
  }

  if (USE_LIVE_SEARCH_MOCKS) {
    const mockResponse = await getFormPostMockResponse(sendFormUrl);
    if (mockResponse) {
      return mockResponse;
    }
  }

  const response = await api.post(sendFormUrl, transformedData);
  return response.data;
};
